// Typelizer digest 04c4232e216f636b7031eefad4f11ae0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/students/:student_id/change_wishlists */
  create: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/students/:student_id/change_wishlists', params, options),
    method: 'post',
  }),

  /** GET /learners/students/:student_id/change_wishlists/:id/edit */
  edit: (
    params: { studentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:student_id/change_wishlists/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /learners/students/:student_id/change_wishlists/:id */
  update: (
    params: { studentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/students/:student_id/change_wishlists/:id', params, options),
    method: 'patch',
  }),
}
